// Partner broker referral. One place to swap the link/copy — every BrokerCard
// in the app reads from here.
export const BROKER_URL =
  'https://www.vantagemarkets.com/hant/open-live-account/?affid=NzE5MDk=&invitecode=4C2DFfrl';

export const BROKER_NAME = 'Vantage';

export const BROKER_POINTS = ['黃金・外匯・指數 CFD', '中文介面與客服', '快速線上開戶'];
